<div class="wordpress-blog-modal">
  <div class="dialog-header">
    <h2 mat-dialog-title>Select WordPress Blog</h2>
    <div class="header-actions">
      <span class="post-count" *ngIf="totalPosts > 0">{{ filteredPosts.length }} / {{ totalPosts }} posts</span>
      <button mat-icon-button (click)="refreshPosts()" [disabled]="isLoading" matTooltip="Refresh posts">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </div>
  
  <mat-dialog-content>
    <div class="filters-section">
      <mat-form-field class="search-field" [nbSpinner]="isLoading">
        <mat-label>Search posts</mat-label>
        <input matInput [formControl]="searchControl" placeholder="Search by title..."
            (keyup.enter)="onEnterSearch()">
        <button mat-icon-button matSuffix class="text-danger clean-button" *ngIf="searchControl.value"
            (click)="clearSearch()">
            <mat-icon>close</mat-icon>
        </button>
        <mat-icon matSuffix *ngIf="!searchControl.value">search</mat-icon>
      </mat-form-field>

      <mat-form-field class="category-filter" [nbSpinner]="isLoading">
        <mat-label>Filter by category</mat-label>
        <mat-select [(value)]="selectedCategoryId" (selectionChange)="onCategoryChange($event.value)">
          <mat-option [value]="0">All Categories</mat-option>
          <mat-option *ngFor="let category of categories" [value]="category.id">
            {{ category.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="posts-wrapper" #scrollContainer>
      <div class="posts-grid" *ngIf="!isLoading">
        <div class="post-card" *ngFor="let post of filteredPosts" (click)="selectPost(post)">
          <div class="post-image">
            <img [src]="getPostImage(post)" [alt]="post.title.rendered" />
            <div class="post-overlay"></div>
            <div class="post-categories" *ngIf="getPostCategories(post)">
              <span>{{ getPostCategories(post) }}</span>
            </div>
          </div>
          <div class="post-content">
            <h3 class="post-title" [innerHTML]="post.title.rendered"></h3>
            <div class="post-meta">
              <div class="post-date" *ngIf="getPostDate(post)">
                {{ getPostDate(post) }} 
                <span>by {{ getPostAuthor(post) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="no-results" *ngIf="!isLoading && filteredPosts.length === 0">
        <mat-icon>search_off</mat-icon>
        <p>No posts found</p>
      </div>

      <div class="loading-container" *ngIf="isLoading">
        <mat-spinner diameter="50"></mat-spinner>
        <p>Loading posts...</p>
      </div>

      <div class="scroll-loading" *ngIf="isLoadingMore && filteredPosts.length > 0">
        <mat-spinner diameter="30"></mat-spinner>
        <span>Loading more posts...</span>
      </div>

      <div class="end-of-posts" *ngIf="!hasMorePosts && filteredPosts.length > 0 && !isLoadingMore">
        <mat-icon>check_circle</mat-icon>
        <span>All posts loaded</span>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Cancel</button>
  </mat-dialog-actions>
</div>
